export default "__VITE_ASSET__63spMoA1__"